/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Domovská stránka',
	homePageTabsLabel: 'Obsah domovské stránky',
	myContent: 'Můj obsah',
	teamContent: 'Obsah Tým',
	folder: 'Složka',
	files: 'Soubory',
	actionMenu: 'Nabídka akcí',
	myFolder: 'Moje složky',

	emptyFolderNoContent: 'Bez obsahu',

	//EmptyStates
	emptyRecentTitle: 'V poslední době jste nezobrazili žádný obsah.',
	emptyStateTitle: 'Začněte přidáním dat',
	emptyStateBody: 'Klepněte výše na volbu Odeslat data, nebo data odešlete přetažením.',
	emptySearchResultTitle: 'Hledání nevrátilo žádné výsledky.',
	emptyPortalTitle: 'Žádné portály',
	emptyPortalBody: 'Nyní nemáte žádné portály.',
	emptyWsProjectTitle: 'Začněte vytvořením zápisníku v produktu Watson Studio.',
	emptyWsProjectBody: 'Když se vrátíte do produktu Cognos Analytics, váš zápisník se zde objeví.',
	emptyFilteredResultTitle: 'Použité filtry nevrátily žádné výsledky.',
	emptyDialogViewTitle: 'Žádné položky',
	removeFromRecents: 'Odebrat z nedávných',

	// Welcome Banner
	welcomeBannerGreeting: 'Dobrý den, vítejte v produktu Cognos Analytics with Watson.',
	welcomeBannerDescription: 'Produkt Cognos Analytics with Watson pomáhá uživatelům se samoobslužnými analytickými nástroji na bázi AI. Podívejte se, jak automatizovaná příprava dat, zjišťování dat a vizualizace mohou podpořit jistotu rozhodování.',
	welcomeBannerDescription_trialUser: 'Můžete rovnou začít, když se podíváte na naše úvodní video, prohlídku produktu a kartu Začínáme.',
	takeTourButtonLabel: 'Absolvovat prohlídku produktu',
	watchVideoButtonLabel: 'Sledovat video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Opravdu chcete vypnout uvítací pruh na domovské stránce? Můžete ho kdykoli znovu zapnout pomocí voleb Profil a nastavení > Nastavení > Obecné. ',
	hideWelcomeBannerTitle: 'Vypnout uvítací pruh',
	ok: 'OK',
	cancel: 'Storno',
	warn: 'Varování',
	//howto video dialog
	modal_how_title: 'Sledovat přehled produktu Cognos Analytics',
	modal_overview_title: 'Sledovat přehled produktu Cognos Analytics',
	modal_how_play: 'Přehrát video',
	modal_how_video_title_overview: 'Přehled',
	modal_how_video_title_getStarted: 'Začínáme s verzí 11.2',
	modal_how_video_title_newUI: 'Vítejte v novém prostředí Cognos',
	modal_how_video_title_dataModule: 'Přehled datových modulů',
	modal_how_video_title_explore: 'Přehled prozkoumání dat',
	modal_how_video_title_dashboard: 'Přehled interaktivních panelů dashboard',
	modal_how_video_title_reporting: 'Přehled vytváření sestav',
	modal_how_video_title_mobile: 'Síla produktu Cognos ve vašich rukách',

	// Toolbar
	search: 'Hledat',
	addFolder: 'Přidat složku',
	addLink: 'Přidat odkaz',
	filter: 'Filtr',
	sort: 'Řadit',
	settings: 'Nastavení',
	tilesView: 'Zobrazení dlaždic',
	listView: 'Zobrazení seznamu',
	columnView: 'Zobrazení sloupců',
	backToSearch: 'Zpět na výsledky hledání',

	// Toolbar Actions
	sortBy: 'Seřadit podle',
	sortOrder: 'Seřadit',
	name: 'Název',
	modifiedTime: 'Změněno',
	type: 'Typ',
	ascending: 'Vzestupně',
	descending: 'Sestupně',
	resetSort: 'Resetovat řazení',

	filterType: 'Typ',
	filterModificationTime: 'Změněno',
	all: 'Vše',
	today: 'Dnes',
	yesterday: 'Včera',
	pastWeek: 'Minulý týden',
	pastMonth: 'Minulý měsíc',
	resetFilters: 'Resetovat filtry',
	resultLimit: 'Limit výsledků',

	filterSearchPlaceHolder: 'Filtrovat podle klíčových slov',

	resetFilterTag: 'Klepnutím na X resetujete filtry.',
	filterTagToolTip: 'Použité filtry: %{appliedFilters}.',

	folderName: 'Název složky',
	addAFolder: 'Přidat složku',
	add: 'Přidat',
	error: 'Chyba',
	newFolderDefaultName: 'Nová složka',
	toastCreateNewFolder: 'Složka %{nameOfFolder} byla vytvořena v %{tabName}.',
	folderAdded: 'Přidána složka',
	refresh: 'Obnovit',
	openFolder: 'Otevřít složku',

	addAUrl: 'Přidat adresu URL',
	linkName: 'Název adresy URL',
	linkNamePlaceholder: 'Přidat název adresy URL',
	linkDescription: 'Popis (volitelný)',
	linkDescriptionPlaceholder: 'Přidat popis',
	linkUri: 'Adresa URL',
	linkUriPlaceholder: 'Přidat adresu URL s přijatelnou doménou',
	acceptableDomains: 'Přijatelné domény',
	viewAcceptableDomains: 'Zobrazit přijatelné domény',
	mandatoryField: 'Povinné pole',
	linkAdded: 'Přidána adresa URL',
	toastCreateNewLink: 'Odkaz %{nameOfLink} byl přidán do %{tabName}.',
	noEntries: 'V seznamu přijatelných domén nejsou žádné položky. Obraťte se na administrátora.',
	unacceptableDomain: 'Adresa URL používá neplatnou doménu. Klepnutím na volbu Zobrazit přijatelné domény zobrazíte seznam domén, které můžete použít.',

	compact: 'Kompaktní',
	short: 'Krátký',
	default: 'Výchozí',
	rowSize: 'Velikost řádku',

	// GroupyByTypes
	folders: 'Složky',
	reports: 'Sestavy',
	dashboards: 'Panely dashboard',
	data: 'Data',
	packages: 'Balíky',
	explorations: 'Prozkoumání',
	stories: 'Scénáře',
	notebooks: 'Zápisníky',
	others: 'Ostatní',

	// Error Messages
	itemsOverLimit: 'Zadaný název "%{itemName}" překročil maximální povolenou délku (20). Chcete-li pokračovat, zadejte jiný název.',
	errorMessageLengthFolderName: 'Zadejte název složky. Délka názvu nesmí překročit 255 znaků.',
	errorMessageLengthLinkName: 'Zadejte název odkazu. Délka názvu nesmí překročit 255 znaků.',
	toastLaunchPerspectiveError: 'Objekt %{objectType} nelze otevřít.',
	errorNoAccessTitle: 'Zdá se, že k tomuto obsahu nemáte přístup.',
	errorNoAccessBody: 'Kontaktujte administrátora nebo pomocí tohoto odkazu vyhledejte další informace:',
	errorEnableExternalContent: 'Povolení externího obsahu',

	//TableHeader
	lastAccessed: 'Poslední přístup',
	location: 'Umístění',
	tenant: 'Tenant',

	// GetStartedTab
	getStartedLabel: 'Začínáme s produktem IBM Cognos Analytics',
	learningHowToLabel: 'Vzdělávací prostředky',
	learningHowToDescription: 'Rozšiřte své znalosti a získejte pomoc připojením ke komunitě, čtením dokumentace a sledováním videí.',
	learningHowToActionLabel: 'Spustit podokno vzdělávání',
	howToVideosLabel: 'Videa s postupy',
	howToVideosDescription: 'Naučte se, jak používat produkt IBM Cognos Analytics a získávat náhledy na svá data.',
	howToVideosActionLabel: 'Sledovat videa',
	acceleratorCatalogLabel: 'Katalog akcelerátorů',
	acceleratorCatalogDescription: 'Procházejte rostoucí katalog oborového použití, návody s osvědčenými postupy, vlastní vizualizace a další.',
	acceleratorCatalogActionLabel: 'Procházet katalog',
	sampleSectionTitle: 'Ukázky',
	sampleSectionDescription: 'Experimentujte s příklady, které ukazují všechny možnosti nabízené produktem Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Postup vytvoření prvního panelu dashboard',
	createDashboardSampleDescription: 'Zahajte svou analytickou kariéru pomocí panelů dashboard produktu Cognos.',
	nlaSampleTitle: 'Ukázková sestava',
	nlaSampleDescription: 'Prozkoumejte možnosti produktu Cognos Analytics Report pomocí tohoto příkladu, který analyzuje aktivitu člena s věrnostní kartou na konci roku.',
	sankeySampleTitle: 'Sankeyův',
	sankeySampleDescription: 'Rozšiřte svou knihovnu vizualizací o vlastní vizualizace, jako je Sankeyův diagram.',
	viewAllSamplesActionLabel: 'Zobrazit všechny ukázky',
	byFeatureTitle: 'Podle funkce',
	byFeatureDescription: 'Procházejte ukázky podle funkce, jako jsou funkce jádra, vlastní ovládací prvky, rozšíření, zápisníky a relativní data.',
	byIndustryTitle: 'Podle oboru',
	byIndustryDescription: 'Procházejte ukázky podle oboru, jako je autopříslušenství, bankovnictví a další.',
	// SamplesTab
	sampleTabTitle: 'Získejte inspiraci z našich předem připravených ukázek',
	sampleTabLabel: 'V katalogu akcelerátorů najdete další ukázky a rozšíření od společnosti IBM, partnerů a zákazníků',

	// quickLaunch
	quickLaunchLabel: 'Rychlé spuštění',
	expand: 'Rozbalit',
	collapse: 'Sbalit',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Začněte výběrem toho, co chcete vytvořit.',

	// contentPageView
	contentPageTitleLabel: 'Obsah',
	uploadFile: 'Odeslat data',
	new: 'Nový',
	create: 'Vytvořit',
	more: 'Další',

	// open dialog
	selectDataSourcesToAdd: 'Vyberte přidávaný zdroj nebo zdroje dat.',
	openDialogDefaultTitle: 'Otevřít',

	// save dialog
	save: 'Uložit',
	saveAs: 'Uložit jako',
	saving: 'Ukládání...',
	selectedDestination: 'Vybraný cíl: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' již existuje s jiným typem. Zadejte jiný název.',
	confirmOverwriteTitle: 'Potvrdit nahrazení existujících dat',
	confirmOverwriteMsg: 'Soubor \'%{nameOfFile}\' již existuje. Chcete nahradit jeho data daty obsaženými ve vybraném souboru?',

	// copy move dialog
	copy: 'Kopírovat',
	move: 'Přesunout',
	copyOrMove: 'Kopírovat nebo přesunout: ',
	copyOnly: 'Kopírovat ',
	createShortcut: 'Vytvořit zástupce',
	createShortcutDialogTitle: 'Vytvořit zástupce: ',

	// External asset types
	wsProject: 'Projekt produktu Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Balík',
	dataModule: 'Datový modul',
	exploration: 'Prozkoumání',
	mode: 'Režim',
	live: 'Živá',
	snapshot: 'Snímek',
	noSnapshotsFound: 'Nebyl nalezen žádný snímek.',
	uploadedFile: 'Odeslaný soubor',
	fileUpload: 'Odeslat data',
	dataSetEx: 'Datová sada',
	externalRepository: 'Externí úložiště',
	queryMode: 'Režim dotazů',
	queryModeCompatible: 'Kompatibilní',
	queryModeDynamic: 'Dynamický',
	report: 'Sestava',
	activeReport: 'Aktivní sestava',
	query: 'Dotaz',
	analysis: 'Analýza',
	dashboard: 'Panel dashboard',
	dashboardTemplate: 'Šablona panelu dashboard',
	jupyterNotebook: 'Zápisník',
	wsNotebook: 'Zápisník produktu Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Scénář',
	workspace: 'Pracovní prostor',
	pagelet: 'Stránka',
	content: 'Obsah',
	directory: 'Prostor jmen',
	dataSet: 'Datová sada',
	powerPlayCube: 'Krychle PowerPlay',
	powerPlayReport: 'Sestava aplikace PowerPlay',
	powerPlay8Report: 'Sestava aplikace PowerPlay',
	setPowerPlay8ReportOptions: 'Nastavit volby sestavy PowerPlay',
	powerPlay8ReportView: 'Zobrazení sestavy PowerPlay',
	reportTemplate: 'Šablona sestavy',
	packageConfigurations: 'Konfigurace balíku',
	agent: 'Agent',
	agentDefinition: 'Definice agenta',
	agentDefinitionView: 'Zobrazení agenta',
	dataMovementTask: 'Úloha přesunu dat',
	dataMovementTaskAlias: 'Alias úlohy přesunu dat',
	document: 'Dokument',
	DocumentRetention: 'Vlastnosti dokumentu',
	jobDefinition: 'Definice úlohy',
	job: 'Úkol',
	jobs: 'Úkoly',
	metricsDataSourceETLTask: 'Úloha nástroje ETL zdroje dat metrik',
	metricsExportTask: 'Úloha exportu metrik',
	metricsFileImportTask: 'Úloha importu souboru metrik',
	metricsMaintenanceTask: 'Úloha udržování metrik',
	planningTask: 'Úloha plánování',
	shortcut: 'Zástupce',
	shortcuts: 'Zástupci',
	URL: 'Adresa URL',
	launchable: 'Spustitelný',
	dataSetFolder: 'Složka datové sady',
	ViewAccessibleLabel: 'Zobrazit %{label}',
	overrideReportOptions: 'Potlačit výchozí volby sestavy',
	formats: 'Formáty',
	saveReport: 'Uložit sestavu',
	reportView: 'Zobrazení sestavy',
	reportviews: 'Zobrazení sestav',
	html: 'HTML',
	pdf: 'PDF',
	spreadsheetML: 'Excel',
	xlsxData: 'Data aplikace Excel',
	csv: 'CSV',
	xml: 'XML',
	txt: 'TXT',
	role: 'Role',
	namespace: 'Prostor jmen',
	namespaceFolder: 'Složka prostoru jmen',
	adminFolder: 'Složka administrátora',
	//Details
	details: 'Podrobnosti',
	open: 'Otevřít',
	created: 'Vytvořeno',
	modified: 'Změněno',
	owner: 'Vlastník',
	dataSource: 'Zdroj dat',
	share: 'Sdílet',
	addToFavorites: 'Přidat k oblíbeným',
	properties: 'Vlastnosti',
	detailsEmptyStateBody: 'Vyberte položku, abyste zobrazili její podrobnosti',
	editNameAndDescription: 'Upravit název a popis',
	none: 'Žádný',
	setPdfOptions: 'Nastavit volby PDF',
	runOptions: 'Volby spuštění',

	//rename dialog
	nameInvalid: 'Název je neplatný',
	namePlaceholder: 'Zadejte název',
	description: 'Popis',
	descriptionInvalid: 'Popis nesmí překročit 350 znaků.',
	descriptionPlaceholder: 'Zadejte popis',
	errorMessageApostropheError: 'Zadejte název souboru, který neobsahuje znaky \' ani ".',
	renameCollisionError: '%{name} již existuje. Zkuste použít jiný název.',
	unknownRenameError: 'Přejmenování položky se nezdařilo. Obraťte se o další pomoc na administrátora.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Určenou složku nelze otevřít.',

	//Upload
	uploadToFolder: "Odeslat do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Odeslat do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> a spustit %{launchAction}",
	quickUpload: "Rychlé odeslání",
	quickUploadAndLaunch: "Přetažením soubory odešlete do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> a otevřete v jednom z následujících prostorů.",
	unsupportedFilesSingle: "Soubor %{files} nebyl odeslán, protože je neplatný pro Rychlé spuštění.",
	unsupportedFilesMultiple: "Soubory nebyly odeslány, protože všechny vybrané soubory musí být platné pro použití Rychlého spuštění.",
	unsupportedFilesSingleInvalid: "Soubor %{files} je neplatný.",
	unsupportedFilesMultipleInvalid: "Soubory %{files} jsou neplatné.",
	supportedFileTypes: "Povoleny jsou pouze následující typy souborů: %{extensions}.",
	uploadDragAndDrop: "Přetáhnout",
	uploadDragAndDropMessage: "Přetáhněte soubor sem, abyste ho odeslali do <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Vyhledávací kritéria \'%{searchTerm}\' byla uložena.',
	searchWasntSaved: 'Vyhledávací kritéria \'%{searchTerm}\' nebyla uložena.',
	searchSuggestions: 'Návrhy',
	savedSearch: 'Uložená hledání',
	searchWasDeleted: 'Vyhledávací kritéria \'%{searchTerm}\' byla odstraněna.',
	searchWasntDeleted: 'Vyhledávací kritéria \'%{searchTerm}\' nebyla odstraněna.',
	savedBarTitle: 'Hledání produktu Cognos Analytics',
	searchContentPageTitle: 'Hledat',
	searchContentPageTitleLabel: 'Zobrazení výsledků pro \'%{searchTerm}\'',
	showingSearchRsult: 'Zobrazení %{resultCount} položek',
	saveSearch: 'Uložit hledání',
	saveTenSearches: 'Můžete uložit 10 hledání.',
	deleteASearch: 'Odstraňte některou položku, abyste mohli uložit jinou.',
	close: 'Zavřít',
	allContent: 'Veškerý obsah',
	searchResultIn: 'Výsledky hledání zahrnují: ',
	//recent view
	recents: 'Nedávné',
	noAccessRecent: 'Bez přístupu',
	noAccessRecentMsg: 'K tomuto aktivu nemáte přístup. Je možné, že byl zakázán či odstraněn nebo že vaše oprávnění byla omezena. Ověřte stav aktiva v očekávaném zdrojovém umístění. Klepnutím na tlačítko OK můžete aktivum odebrat z nedávno použitých položek.',
	noAccessMsg: 'K tomuto aktivu nemáte přístup. Je možné, že byl zakázán či odstraněn nebo že vaše oprávnění byla omezena.',

	//contextToolbar
	itemsSelected: 'Počet vybraných položek: %{nameOfSelection}',
	itemSelected: 'Počet vybraných položek: %{nameOfSelection}',

	//properties
	general: 'Obecné',
	schedule: 'Časový plán',
	permission: 'Oprávnění',
	capabilities: 'Schopnosti',
	propertiesTabsLabel: 'Obsah vlastností',
	searchPath: 'Vyhledávací cesta',
	id: 'ID',
	language: 'Jazyk',
	setLanguage: 'Nastavit jazyk',
	entryOptions: 'Volby položky',
	setPackage: 'Nastavit balík nebo modul',
	sourcePackage: 'Zdrojový balík nebo modul dat',
	associatedSourceAgent: 'Zdrojový balík',
	setAssociatedSourceAgent: 'Nastavit balík',
	sourceAgent: 'Zdrojový agent',
	setSourceAgent: 'Nastavit zdrojového agenta',
	setCapabilities: 'Nastavit schopnosti',
	disableEntry: 'Zakázat tuto položku',
	hideEntry: 'Skrýt tuto položku',
	permissions: 'Oprávnění',
	promptForValues: 'Vyzvat k zadání hodnot',
	yes: 'Ano',
	no: 'Ne',
	setValues: 'Nastavit hodnoty',
	moreOptions: 'Další volby',
	reportFormat: 'Formát sestavy',
	enableAccessibilitySupport: 'Povolit podporu usnadnění přístupu',
	displayOfRunHistory: 'Zobrazení historie spouštění',
	occurrences: 'Výskyty',
	days: 'Den (nebo dny)',
	months: 'Měsíc(e)',
	displayOfReportOutputVersions: 'Zobrazení verze výstupu sestavy',
	defaultDisplayOfPortalAction: 'Výchozí akce portálu',
	viewMostRecentReport: 'Zobrazit nejnovější sestavu',
	runTheReport: 'Spustit sestavu',
	openWithReportStudio: 'Otevřít v aplikaci Report Studio',
	rowsPerPageInHtmlReports: 'Počet řádků na stránce v sestavách HTML',
	enableSelectionBasedInteractivity: 'Povolit interaktivitu založenou na výběru',
	enableAlertsAboutNewVersions: 'Povolit upozornění na nové verze',
	enableEnhancedUserFeaturesInSavedOutputVersions: 'Povolit rozšířené uživatelské funkce v uložených verzích výstupu',
	enableCommentsInSavedOutputVersions: 'Povolit komentáře v uložených verzích výstupů',
	run: 'Spustit',
	runWithUsersCredentials: 'S pověřeními uživatele',
	runWithOwnerCapabilities: 'Se schopností vlastníka',
	runAsOwner: 'Jako uživatel %{ownerName}',
	actionLabelOn: 'Zapnuto',
	actionLabelOff: 'Vypnuto',
	openReport: 'Upravit',
	openAnalysis: 'Otevřít v aplikaci Analysis Studio',
	openQuery: 'Otevřít v aplikaci Query Studio',
	openPowerPlay8Report: 'Otevřít v aplikaci PowerPlay Studio',
	openInteractiveReport: 'Upravit',
	read: 'Číst',
	write: 'Zapisovat',
	execute: 'Provést',
	setPolicy: 'Nastavit zásadu',
	full: 'Plný',
	traverse: 'Procházet',
	grant: 'Udělit',
	deny: 'Zamítnout',
	permissionCustom: 'Vlastní',
	permissionDetailsColumnAccess: 'Přístup',
	permissionDetailsColumnPermission: 'Oprávnění',
	permissionDetailsColumnAction: 'Akce',
	permissionSetAccess: 'Nastavit přístup',
	permissionRead: 'Číst',
	permissionRun: 'Spustit',
	permissionWrite: 'Zapisovat',
	permissionFull: 'Plný',
	unavailable: 'Nedostupné',
	unkownSource: 'Neznámé, podrobnosti získáte otevřením sestavy',
	tenantSettings: 'Nastavení tenanta',
	tenantSet: 'Tenant aktualizován',
	tenantSetError: 'Chyba při nastavení tenanta',
	tenantClear: 'Tenant vymazán',
	tenantClearError: 'Chyba při vymazání tenanta',
	shortcutTo: 'Zástupce objektu',
	sourceReport: 'Zdrojová sestava',
	setSourceReport: 'Nastavit zdrojovou sestavu',
	setSourceLocation: 'Nastavit umístění zdroje %{itemName}',
	linkPackageOrModule: 'Propojit %{itemName} s balíkem nebo datovým modulem.',
	linkPackage: 'Propojit %{itemName} s balíkem',
	externalRepositories: 'Externí úložiště',
	sizeByte: '%{value} B',
	sizeKiloByte: '%{value} kB',
	sizeMegaByte: '%{value} MB',
	sizeGigaByte: '%{value} GB',
	sizeTeraByte: '%{value} TB',
	sizePetaByte: '%{value} PB',
	refreshedDatetime: 'Čas obnovení',
	size: 'Velikost',
	tenantsWarningMessage: 'Změna tenanta položky změní tenanta také pro podřízené položky.',
	confirmClearTenantText: 'Vymazání hodnoty \'None\' může ostatním tenantům povolit přístup k obsahu. Klepnutím na tlačítko OK nastavíte položku jako veřejnou, nebo klepnutím na tlačítko Storno zachováte aktuálního tenanta.',
	confirmClearTenant: 'Potvrdit smazání tenanta',
	currentValues: 'Současné hodnoty',
	emptyPromptValues: 'Aktuálně nejsou k dispozici žádné hodnoty',
	editValues: 'Upravit hodnoty',
	clear: 'Vymazat',
	source: 'Zdroj',
	dataRefreshed: 'Data jsou obnovena',
	//PDF options
	pdfOptions: 'Možnosti PDF',
	set: 'Sada',
	portrait: 'Na výšku',
	landscape: 'Na šířku',
	letter: 'Letter',
	legal: 'Právní',
	elevenxSeven: '11x17',
	A3: 'A3',
	A4: 'A4',
	b4jis: 'B4JIS',
	b5jis: 'B5JIS',
	orientation: 'Orientace',
	pageDefination: 'Velikost papíru',
	openPasswordRequired: 'Požadovat heslo pro otevření sestavy',
	accessPasswordRequired: 'Požadovat heslo pro přístup k sestavě',
	emptyPassword: 'Heslo nemůže být prázdné',
	password: 'Heslo',
	enterPassword: 'Zadat heslo',
	confirmPassword: 'Potvrzení hesla',
	passwordMatchError: 'Hesla se neshodují',
	gateway: 'Komunikační brána',
	pageLayout: 'Rozvržení stránky',
	pageStyle: 'Styl',
	setUrl: 'Nastavit adresu URL',
	numberRows: 'Počet řádků',
	numberColumns: 'Počet sloupců',
	timeToRefresh: 'Čas pro obnovení',
	lastRefreshedBy: 'Obnovil',
	unknown: 'Neznámý',
	unknownUpdateError: 'Aktualizace položky se nezdařila. Obraťte se o další pomoc na administrátora.',
	editQuery: 'Upravit dotaz',
	greaterOrEqual: 'Větší než nebo rovno %{upperboundValue}',
	lessOrEqual: 'Menší než nebo rovno %{lowerboundValue}'
});
